var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.405 10.88H9.593l2.394 6.62zM6 10.18h2.868l1.56-2.68H8.599zm.02.7 4.726 5.248L8.85 10.88zm7.2 5.285 4.76-5.285h-2.83zM18 10.18 15.401 7.5h-1.828l1.559 2.68zM12.763 7.5l1.56 2.68H9.677l1.56-2.68z",
    clipRule: "evenodd"
  })));
};
export default SvgDiamond;